export default __webpack_public_path__ + "static/media/calm-waters.4d904a43.jpg";